import { http } from '@pendo/http';

export function fetchExtensions () {
    return http.get('/api/s/_SID_/extension').then((res) => res.data);
}
